/* jshint esversion: 6 */
import { of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    SocialActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSocialsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        let state = state$.value;
        // Short circuit pulls of the main list --- CRUD operations will work on the state
        // so in theory we only need to pull the main list once
        // TODO: determine if we need an expiration
        if (state.socials.list.length && (action.force === undefined || action.force === false)) {
            return of(SocialActions.receiveSocials(state.socials.list));
        } else {
            return api(action.type, state$, null, null, SocialActions.receiveSocials);
        }

    })
);

export const fetchSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveSocial))
);

export const updateSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.updatedSocial))
);

export const deleteSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.deletedSocial))
);

export const createSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdSocial))
);

export const createBatchSocialsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CREATE_BATCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdBatchSocials))
);

export const createBatchPollEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_BATCH_POLL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdBatchPoll))
);

export const fetchSocialLogEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LOG && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveSocialLog))
);

export const checkSocialAuthEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CHECK_AUTH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.checkedSocialAuth))
);

export const fetchSocialTypesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_TYPE_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, SocialActions.receiveSocialTypes))
);

export const fetchSocialTypeDefaultsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_TYPE_DEFAULTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveSocialTypeDefaults))
);

export const fetchQueueCountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_QUEUE_COUNT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveQueueCount))
);

export const fetchFacebookGroupStatusEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_FB_GROUP_STATUS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveFacebookGroupStatus))
);

export const fetchYouTubeCategoriesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_CATEGORIES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveYouTubeCategories))
);

export const fetchYouTubePlaylistsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_PLAYLISTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveYouTubePlaylists))
);

export const fetchSocialPostAnalyticsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_POST_ANALYTICS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.receiveSocialPostAnalytics))
);
